
/**
 * Information associated with AFM (Airport Facilities Manager) Other table
 */
export class AfmOther {
  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * Web site URL (not currently used, using the one from the Airports table, but want to move to using this one)
   */
  websiteUrl: string;

  /**
   * the runway to use when wind doesn't dictate using another
   */
  lightWindRwy: string;

  /**
   * Last update date for this record
   */
  updateDate: Date;

  /**
   * User ID who last modified this record
   */
  updateBy: string;

  /**
   * is there GA Transient parking?
   */
  gatParking: boolean;

  /**
   * GA Transient description
   */
  gatDescription: string;

  /**
   * Is the GA Transient parking charted?
   */
  gatCharted: boolean;

  /**
   * Parses noise abatement data
   * @param data {any} AFM Other data as returned by API
   * @return {AfmOther} Parsed AFM Other data
   */
  static parse(data: any): AfmOther {
    return {
      sourceId: data.sourceId,
      websiteUrl: data.websiteUrl || null,
      lightWindRwy: data.lightWindRwy || null,
      gatParking: data.gatParking,
      gatDescription: data.gatDescription || null,
      gatCharted: data.gatCharted,
      updateDate: data.updateDate ? new Date(data.updateDate) : null,
      updateBy: data.updateBy || null
    };
  }
}
